export const cardFormTypes = {
  ADD_PAYMENT_METHOD: 'add-payment-method',
  CHANGE_PAYMENT_METHOD: 'change-payment-method',
  EDIT_BILLING_INFO: 'edit-billing-info',
};
